import { USER_ROLE } from "../constants";

export const isProtectedTabs = (role: any, tab: any) => {
  const restrictedTabs = ["expense", "bankAccount", "subscription"];

  return role.includes(USER_ROLE.OPERATOR) && restrictedTabs.includes(tab);
};
